


















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import AppSelector from '@/components/AppSelector.vue'
import { ICarrierAdditionalInput } from '@/modules/Carrier/interfaces/carrier-form'
import { documentDeliveryValues } from '@/modules/Carrier/helpers/carrier'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppPhoneInput
  }
})
export default class CarrierFormAdditional extends Vue {
  @Prop({ type: Object as () => ICarrierAdditionalInput }) value!: ICarrierAdditionalInput

  deliveryOptions = documentDeliveryValues

  downloadsOptions = ['Yes', 'No']

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
